import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Article } from '../../../components/canvasflow/article/Article';
import { Swiper, SwiperSlide } from 'swiper/react';
import { ResponsiveModeContext } from './ResponsiveModeContext';
import SwiperCore, { EffectFade } from 'swiper/core';

import cssStyles from './ResponsiveMode.module.css';

SwiperCore.use([EffectFade]);

// Import Swiper styles
import 'swiper/swiper.scss';
import { AppContext } from '../../../services/AppContext';
import { useEffect } from 'react';
export const Carousel = (props) => {
	const { styles } = useContext(AppContext);
	let {
		articles,
		fontSize,
		article,
		onTransitionEnd,
		swiper,
		setSwiper,
		onLightboxMode,
		isLightboxMode
	} = useContext(ResponsiveModeContext);
	const { index } = article;
	if (props.onTransitionEnd) {
		onTransitionEnd = props.onTransitionEnd;
	}
	useEffect(() => {
		if (!swiper) {
			return null;
		}
		swiper.slideTo(index, 750, false);
	}, [index]);

	return (
		<div
			disabled={!isLightboxMode}
			style={{
				height: '100vh',
				width: '100%',
				margin: 'auto',
			}}
		>
			<Swiper
				updateOnWindowResize={true}
				initialSlide={index}
				scrollbar={{
					draggable: false,
				}}
				onSwiper={(s) => {
					setSwiper(s);
				}}
				onSlideChange={(s) => {
					const { activeIndex } = s;
					onTransitionEnd({
						index: activeIndex,
					});
				}}
			>
				{articles.map(({ id, style, components }, i) => {
					let isVoid = isArticleVoid({
						total: articles.length,
						currentIndex: index,
						index: i,
					});
					return (
						<SwiperSlide
							key={i}
							className={cssStyles['article-swiper']}
						>
							<Article
								id={id}
								index={i}
								style={`${style}`}
								isVoid={isVoid}
								fontSize={fontSize}
								styles={styles}
								components={components}
								onLightboxMode={onLightboxMode}
							/>
						</SwiperSlide>
					);
				})}
			</Swiper>
		</div>
	);
};

Carousel.propTypes = {
	onTransitionEnd: PropTypes.func,
};

function isArticleVoid({ total, currentIndex, index }) {
	if (total > 5) {
		const lastArticleIndex = total - 1;
		if (currentIndex === 0) {
			// First and second page
			if (index !== 0 && index !== 1 && index !== 2) {
				return true;
			}
		} else if (currentIndex === lastArticleIndex) {
			// Last 2 articles
			if (
				index !== lastArticleIndex &&
				index !== lastArticleIndex - 1 &&
				index !== lastArticleIndex - 2
			) {
				return true;
			}
		} else {
			if (
				index !== currentIndex &&
				index !== currentIndex - 1 &&
				index !== currentIndex - 2 &&
				index !== currentIndex + 1 &&
				index !== currentIndex + 2
			) {
				return true;
			}
		}
	}
	return false;
}
